import { darken, lighten } from 'polished';
import styled from 'styled-components';

interface IContainerProps {
  hasError?: string;
  isDisabled?: boolean;
}

export const Container = styled.label<IContainerProps>`
  display: flex;
  position: relative;
  width: 100%;
  margin-bottom: 1rem;

  border: 1px solid
    ${({ hasError, theme }) => (hasError ? theme.colors.danger.color : theme.colors.border)};
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  box-shadow: 1px 4px 0px 0px rgba(118, 136, 149, 0.2) inset;
  transition: all 150ms ease;

  &:hover {
    border: 1px solid hsl(0, 0%, 70%);
  }

  input {
    padding: 1rem 0.9rem;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    &[type='number'] {
      -moz-appearance: textfield;
    }
  }

  input:hover,
  input:focus,
  input:active,
  input {
    flex: 1;

    width: 100%;
    height: 100%;

    background-color: transparent;
    border-width: 0 !important;

    font-size: 1rem;
    color: ${({ theme }) => theme.colors.texts};
    box-shadow: none;

    &#token {
      width: 15.1875rem;
      text-align: center;
      margin: auto;
      height: 3.0625rem;
      font-size: 1.5rem;
    }

    &:hover {
      border: 1px solid
        ${({ hasError, theme }) => (hasError ? theme.colors.danger.color : theme.colors.border)};
    }

    &::placeholder {
      font-size: 1rem;
      color: ${({ theme }) => lighten(0.2, theme.colors.texts)};
    }

    @media (max-width: 991px) {
      font-size: 1rem;
    }
  }

  input:disabled {
    background-color: ${({ theme }) => theme.colors.medium.color};
    opacity: 0.3;

    cursor: not-allowed;
  }

  :has(input[disabled]) {
    border-color: ${({ theme }) => theme.colors.medium.color};
  }
`;

export const Error = styled.span.attrs({
  className: 'error',
})`
  display: block;

  color: ${({ theme }) => theme.colors.danger.color} !important;
  font-size: 0.7rem !important;
  font-weight: bold;
  text-align: left;

  padding: 0.3rem;
  margin-top: -1rem;
  margin-bottom: 0.5rem;
`;

export const PreText = styled.p`
  margin-bottom: 0;
  font-weight: bold;
`;

export const Label = styled.div`
  position: relative;

  display: flex;
  flex-direction: row;
  gap: 0.5rem;

  margin-bottom: 0.5rem;

  p {
    margin: 0;

    text-align: left;
    font-size: 0.875rem;
    line-height: 1.2rem;
    color: ${({ theme }) => theme.colors.texts};
    font-weight: 600;

    span {
      font-family: inherit;
    }
  }

  .required {
    color: ${({ theme }) => theme.colors.danger.color};
  }
`;

interface IPasswordIconContainerType {
  hasLabel: boolean;
}
export const PasswordIconContainer = styled.button<IPasswordIconContainerType>`
  min-width: 1px !important;

  margin: 0 1rem;

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0rem;

  background: none;
  border-width: 0;

  svg {
    color: ${({ theme }) => theme.colors.dark.color};
    width: 1.2rem !important;
    height: 1.2rem !important;
    opacity: 0.8;
  }
`;

export const IconContainer = styled.div<IContainerProps>`
  position: relative;
  flex: 1;

  & > div {
    background-color: ${({ theme, isDisabled }) => (isDisabled ? 'none' : theme.colors.white)};
    opacity: ${({ isDisabled }) => (isDisabled ? 0.3 : 1)};

    position: absolute;
    right: 0;
    top: 0;
    z-index: 10;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 1rem;

    svg {
      color: ${({ hasError, theme }) =>
        hasError ? theme.colors.danger.color : theme.colors.primary.color};
      width: 1rem !important;
    }
  }
`;

export const FieldRulesContainer = styled.div<IContainerProps>`
  position: absolute;
  z-index: 100;
  top: 100%;
  width: 100%;
  margin-top: -0.5rem;

  background-color: ${({ theme }) => theme.colors.medium.color};

  padding: 0.5rem 1rem;

  p:last-of-type {
    margin-bottom: 0;
  }

  p,
  span,
  strong {
    color: ${({ theme }) => theme.colors.dark.color};

    font-size: 0.8rem;
    line-height: 1rem;
  }

  strong {
    font-weight: bold;
  }

  border: 1px solid
    ${({ hasError, theme }) =>
      hasError ? theme.colors.danger.color : darken(0.15, theme.colors.medium.color)};
  border-top-width: 0;

  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
`;
